/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IEstadosDetalles from 'Infotrack@Modelos/smartStock/estadosDetalles/entidades/estadosDetalles';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import EstadosDetallesCM from '../controladorModelo/estadosDetallesCM';
import { acciones, IEstadoEstadosDetalles } from '../reductorEstadosDetalles';
import EstadosDetallesVista from '../vista/tablaEstadosDetallesVista';
import Texto from '@infotrack/presentacion-componentes/texto';

const estadosDetallesCM = new EstadosDetallesCM();

const TableEstadosDetallesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [estadosDetalless, setEstadosDetalless] = React.useState<IEstadosDetalles[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoEstadosDetalles>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarEstadosDetalles();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarEstadosDetalles = () => {
        manejadorIndicadorCargaGlobal(true);
        estadosDetallesCM.consultarEstadosDetalles().then((estadosDetalless) => {
            setEstadosDetalless(estadosDetalless);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadEstadosDetalles?: IEstadosDetalles) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadEstadosDetalles, tipoFormulario } });
    };

    const confirmarEliminacion = (estadosDetalles: IEstadosDetalles) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarEstadosDetalles(estadosDetalles),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarEstadosDetalles = (estadosDetalles: IEstadosDetalles) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        estadosDetallesCM.eliminarEstadosDetalles(estadosDetalles).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <EstadosDetallesVista
            estadosDetalless={estadosDetalless}
            cargarEstadosDetalles={cargarEstadosDetalles}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableEstadosDetallesCV;
